import "./App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import ClientsPage from "./pages/ClientsPage";
import ClientsMaintenancePage from "./pages/ClientsMaintenancePage";
import DashboardPage from "./pages/DashboardPage";
import LoggedTimePage from "./pages/LoggedTimePage";
import LoginPage from "./pages/LoginPage";
import LogSupportPage from "./pages/LogSupportPage";
import LogSupportContactsPage from "./pages/LogSupportContactsPage";
import ReportsPage from "./pages/ReportsPage";
import SettingsPage from "./pages/SettingsPage";
import TeamPage from "./pages/TeamPage";
import TeamMaintenancePage from "./pages/TeamMaintenancePage";
import ImportPage from "./pages/ImportPage";
import AutomaticSummaryLogPage from "./pages/AutomaticSummaryLogPage";

const Protected = ({ children }) => {
  const { staff, checking } = useAuth();
  if (checking) return <div className="app-loading" data-testid="app-loading">Loading Intechify…</div>;
  return staff ? children : <Navigate to="/login" replace />;
};

const AdminProtected = ({ children }) => {
  const { staff, checking } = useAuth();
  if (checking) return <div className="app-loading" data-testid="app-loading">Loading Intechify…</div>;
  return staff?.is_admin ? children : <Navigate to="/" replace />;
};

export default function App() {
  return <AuthProvider><BrowserRouter><Routes><Route path="/login" element={<LoginPage />} /><Route path="/" element={<Protected><DashboardPage /></Protected>} /><Route path="/log-support" element={<Protected><LogSupportContactsPage /></Protected>} /><Route path="/logged-time" element={<Protected><LoggedTimePage /></Protected>} /><Route path="/clients" element={<Protected><ClientsPage /></Protected>} /><Route path="/clients/maintenance" element={<Protected><ClientsMaintenancePage /></Protected>} /><Route path="/team" element={<AdminProtected><TeamPage /></AdminProtected>} /><Route path="/team/maintenance" element={<AdminProtected><TeamMaintenancePage /></AdminProtected>} /><Route path="/reports" element={<Protected><ReportsPage /></Protected>} /><Route path="/settings" element={<AdminProtected><SettingsPage /></AdminProtected>} /><Route path="/automatic-summary-log" element={<AdminProtected><AutomaticSummaryLogPage /></AdminProtected>} /><Route path="/imports" element={<AdminProtected><ImportPage /></AdminProtected>} /><Route path="*" element={<Navigate to="/" replace />} /></Routes></BrowserRouter><Toaster richColors position="top-right" /></AuthProvider>;
}
